var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:currentColor;}.c{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.6661,13.0622c-.3834,.2304-.7596,.4781-1.1274,.743l-2.1808-2.2141c-1.0392-1.0413-2.7257-1.0429-3.7669-.0038-.0013,.0013-.0025,.0025-.0038,.0038h0c-1.0307,1.0359-1.0307,2.7099,0,3.7457l2.2641,2.2308c-1.9908,2.7515-3.0653,6.0597-3.0715,9.4559v3.4097H40.1328v-3.4097c.0112-3.3975-.9806-6.7121-2.9614-9.4725l2.2724-2.2474c1.0344-1.0331,1.0354-2.709,.0023-3.7434-.0008-.0008-.0016-.0016-.0023-.0023h0c-1.0284-1.039-2.7044-1.0475-3.7434-.019-.0064,.0063-.0127,.0127-.019,.019l-2.2641,2.2474c-.413-.2975-.8365-.5733-1.2691-.8272m-15.005,13.415c-1.4487,.004-2.6264-1.1672-2.6305-2.6159s1.1672-2.6264,2.6159-2.6305c1.4487-.004,2.6264,1.1672,2.6305,2.6159,0,.0049,0,.0097,0,.0146,0,1.4447-1.1711,2.6159-2.6159,2.616-.0049,0-.0097,0-.0146,0h.0146Zm13.5702,.1053c-1.4487,.0121-2.6329-1.1526-2.645-2.6013-.0121-1.4487,1.1526-2.6329,2.6013-2.645,1.4487-.0121,2.6329,1.1526,2.645,2.6013,0,.0097,.0001,.0194,0,.029,0,1.4447-1.1712,2.6159-2.6159,2.6159h.0146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.7798,30.5207v10.2305c0,.9658,.783,1.7488,1.7488,1.7488h28.8553c.9618,0,1.7488-.787,1.7488-1.7488v-10.318"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "17.1359 30.4332 23.9563 37.341 30.6916 30.4332"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 23.874,
    y1: 10.8844,
    x2: 23.874,
    y2: 9.4149
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 22.6266,
    y1: 10.5883,
    x2: 20.6527,
    y2: 9.7329
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.874,12.7596c4.3454,0,10.4151-1.3159,10.4151-2.7196,0-1.4037-4.4084-4.54-10.4151-4.54-6.0067,0-10.4151,3.1363-10.4151,4.54s6.0697,2.7196,10.4151,2.7196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.2384,11.4835v1.2761c0,.7786-4.1342,2.6757-8.3644,2.6757-4.2302,0-8.3644-1.8971-8.3644-2.6757v-1.2761"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 25.1214,
    y1: 10.5883,
    x2: 27.0953,
    y2: 9.7329
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 22.0184,
    y1: 30.4332,
    x2: 23.2692,
    y2: 32.2793
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "25.718 35.4705 24.5583 32.2793 23.2692 32.2793 22.1095 35.4705"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 25.8091,
    y1: 30.4332,
    x2: 24.5583,
    y2: 32.2793
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17.1359,
    cy: 35.2349,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17.1359,
    cy: 38.5433,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 30.6916,
    cy: 35.2349,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 30.6916,
    cy: 38.5433,
    r: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 35.1495,
    y1: 33.2944,
    x2: 36.3271,
    y2: 33.2944
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.7798,34.9739c2.5078,0,4.5407-2.0329,4.5407-4.5407"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.97e4d6dbdc53b812daf61282fd8dfd8b.svg";
export { ForwardRef as ReactComponent };